import { css } from '@emotion/react'
import { Theme } from '@mui/material'

export const welcomeTabContainer = () => css`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`

export const videoBox = css`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;

  > video {
    max-width: 100%;
    width: 600px;
  }
`

export const usergroupTable = (theme: Theme) => css`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;

  > * {
    display: flex;
    padding: 24px 0;
    gap: 16px;
    border-bottom: 1px solid ${theme.palette.uintel.main}40;
  }
`

export const scrollContainer = css`
  flex-grow: 1;
  position: relative;
  width: 100%;
`

export const innerScrollContainer = (theme: Theme) => css`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 16px;
  position: absolute;
  height: 100%;
  overflow-y: auto;
  top: 0;

  &::-webkit-scrollbar {
    width: 12px !important;
  }

  &::-webkit-scrollbar-track {
    border-radius: 0px !important;
    border: none !important;
    background-color: ${theme.palette.uintel.main}00 !important;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${theme.palette.uintel.main}40 !important;
    border-radius: 0px !important;
  }
  &::-webkit-scrollbar-thumb:hover {
    background-color: ${theme.palette.uintel.main}60 !important;
  }
`

export const navigatorsTable = (theme: Theme) => css`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 32px;
  width: 100%;
  margin-top: 24px;

  .contact {
    padding-bottom: 52px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    > img {
      max-width: 100%;
      width: 160px;
      height: 160px;
      object-fit: cover;
      border-radius: 50%;
      margin: 8px 0;
      border: 4px solid white;
    }
    > .content {
      display: flex;
      flex-direction: column;
      gap: 4px;

      h3 {
        font-size: 16px;
        font-weight: 700;
        color: black;
        letter-spacing: 0.32px;
        line-height: 155%;
      }

      h4 {
        font-weight: bold;
        color: ${theme.palette.uintel.light};
      }

      .contact-info {
        display: flex;
        gap: 8px;
        align-items: center;
        color: ${theme.palette.uintel.main};
        font-size: 16px;
        font-weight: 500;

        svg {
          color: ${theme.palette.uintel.light};
          height: 20px;
          width: 20px;
        }
      }

      .intro {
        margin: 20px 0;
      }
    }
  }

  .contact:nth-of-type(1),
  .contact:nth-of-type(2) {
    border-bottom: 1px solid ${theme.palette.uintel.main}40;
  }
`

export const clientContactStyle = css`
  margin-top: 12px;
  a {
    color: inherit;
    text-decoration: none;

    // Only underline the email label
    &[href^='mailto:'] > span {
      text-decoration: underline;
    }
  }

  // Fix icon size/alignment
  svg {
    height: 1rem;
    vertical-align: middle;
  }
`
